import type { ProfilePermissions } from "@qendo/permissions";
import { ProfileRole } from "@qendo/profile";
import { useMemo } from "react";
import { DataList } from "~/components/layout/DataList";
import { PermissionItem } from "~/components/layout/team/PermissionItem";
import { Gap, Padding } from "~/constants/layout";
import { Permissions } from "~/entities/profile/permissions";
import { isDifferentMedical } from "~/util/qendo/team";

export type PermissionsOutputProps = {
    permissions?: ProfilePermissions | null;
    role?: ProfileRole | null;
};

export const PermissionsOutput = ({ permissions, role }: PermissionsOutputProps) => {
    const real = useMemo(() => new Permissions(permissions), [permissions]);
    const hide_empty = role === ProfileRole.share;

    return (
        <DataList style={[Padding.sm, Gap.sm]}>
            <PermissionItem hideEmpty={hide_empty} section="profile" permission={real.profile} />
            <PermissionItem hideEmpty={hide_empty} section="goals" permission={real.goals} />
            <PermissionItem hideEmpty={hide_empty} section="team" permission={real.team} />
            <PermissionItem hideEmpty={hide_empty} section="photos" permission={real.photos} />
            <PermissionItem hideEmpty={hide_empty} section="activities" permission={real.activities} />
            <PermissionItem hideEmpty={hide_empty} section="symptoms" permission={real.symptoms} />
            <PermissionItem hideEmpty={hide_empty} section="journal" permission={real.journal} />
            <PermissionItem hideEmpty={hide_empty} section="cycle" permission={real.cycle} />
            <PermissionItem hideEmpty={hide_empty} section="calendar" permission={real.calendar} />
            <PermissionItem hideEmpty={hide_empty} section="documents" permission={real.documents} />
            <PermissionItem hideEmpty={hide_empty} section="medical" permission={real.medical} />
            {isDifferentMedical("allergies", real) && (
                <PermissionItem section="allergies" hideEmpty={hide_empty} permission={real.allergies} />
            )}
            {isDifferentMedical("conditions", real) && (
                <PermissionItem section="conditions" hideEmpty={hide_empty} permission={real.conditions} />
            )}
            {isDifferentMedical("immunisations", real) && (
                <PermissionItem section="immunisations" hideEmpty={hide_empty} permission={real.immunisations} />
            )}
            {isDifferentMedical("medications", real) && (
                <PermissionItem section="medications" hideEmpty={hide_empty} permission={real.medications} />
            )}
            {isDifferentMedical("supplements", real) && (
                <PermissionItem section="supplements" hideEmpty={hide_empty} permission={real.supplements} />
            )}
            {isDifferentMedical("surgeries", real) && (
                <PermissionItem section="surgeries" hideEmpty={hide_empty} permission={real.surgeries} />
            )}
            {isDifferentMedical("triggers", real) && (
                <PermissionItem section="triggers" hideEmpty={hide_empty} permission={real.triggers} />
            )}
        </DataList>
    );
};
